import React from 'react';
import IconButtonSwitch from '../icon-button-switches/IconButtonSwitch';
import {ReactComponent as EditIcon} from '../../../assets/images/icon-edit.svg';

interface Props {
  bordered?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const EditButton = ({className, onClick, disabled, bordered}: Props): React.ReactElement =>
  <IconButtonSwitch ariaLabel='edit'
                    bordered={bordered}
                    disabled={disabled}
                    icon={<EditIcon />}
                    onClick={onClick}
                    className={className}
  />;

export default EditButton;
